

import React from 'react';
import { Box, Typography, Button, Card, CardContent, CircularProgress } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import componentStyles from 'assets/theme/views/auth/login.js';
import componentStylesButtons from 'assets/theme/components/button.js';

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

const ProfileSetupPending = () => {
    const classes = { ...useStyles(), ...useStylesButtons() };
    return (
        <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            minHeight='100vh'
            bgcolor='#f5f6fa'
        >
            <Card
                classes={{ root: classes.cardRoot }}
                style={{ backgroundColor: '#fff', maxWidth: 520, width: '100%' }}
                elevation={4}
            >
                <CardContent classes={{ root: classes.cardContent }} style={{ padding: '3rem 3rem 2.5rem' }}>
                    <Box textAlign='center'>
                        {/* <Box mb={3}>
                            <CircularProgress size={48} thickness={5} color='primary' />
                        </Box> */}
                        <Typography variant="h5" gutterBottom>
                            We're setting up your account...
                        </Typography>
                        <Typography variant="body1" paragraph style={{ color: '#8898aa' }}>
                            This usually takes about 1 minute while we create your CRM and add your products.
                        </Typography>
                        <Typography variant="caption" display='block' style={{ marginBottom: '2rem', color: '#8898aa' }}>
                            Please keep this page open and it will refresh automatically when your account is ready.
                        </Typography>
                        <Button
                            variant='contained'
                            classes={{ root: classes.buttonContainedInfo }}
                            size='large'
                            onClick={() => window.location.reload()}
                        >
                            Refresh Page
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ProfileSetupPending;
